/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Grid, Button } from '@material-ui/core';
import DesktopChangeName from './DesktopChangeName';
import DesktopChangeEmail from './DesktopChangeEmail';
import DesktopChangePassword from './DesktopChangePassword';
import { useDispatch, useSelector } from 'react-redux';
import { getUserProfile } from '../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import EventDispatcher from '../../../state/reducers/EventDispatcher';

const DesktopProfileAndPassword = () => {
    const { firstName, lastName} = useSelector(getUserProfile);
    const dispatch = useDispatch();

    return (
        <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }}>
        <div className="position-relative">
           <h2 className="float-left">Profile &amp; Password</h2>
           <span className="float-right small gray-color">* Required Field</span>
        </div>
        <Grid className="shadowContentGrid contentGrid" container item xs={12}>
        <Grid className="block" item xs={12}>
                <div className="blockHeader">Name</div>
            </Grid>
            <Grid className="blockContent hasForm no-margin-bottom" item xs={9}>
                <DesktopChangeName firstName={firstName} lastName={lastName} />
            </Grid>
            <Grid className="block" item xs={12}>
                <div className="blockHeader">Email Address</div>
            </Grid>
            <Grid className="blockContent hasForm no-margin-bottom" item xs={9}>
                <DesktopChangeEmail />
            </Grid>
            <Grid className="block" item xs={12}>
                <div className="blockHeader">Account Password</div>
            </Grid>
            <Grid className="blockContent hasForm no-margin-bottom password-bottom" item xs={9}>
                <DesktopChangePassword />
            </Grid>
        </Grid>
        <div className="margin-top-2x">
           <Button
                 onClick={() => dispatch(EventDispatcher.handleSubmitProfileAndPassword())}
                 variant="contained"
                 color="primary"
                 data-test="my-account-update-profile"
                 className=""
           >
                 Save
           </Button>
        </div>
     </Grid>
    )

};

export default DesktopProfileAndPassword;